module.exports = __webpack_public_path__ + "img/c4.2e173c2b.jpg";